const callAnalytics = (method, ...args) => {
  if (window.analytics) {
    window.analytics[method](...args);
  }
};

export default callAnalytics;
